import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";
import { extractRequestFromQueryKey } from "../../../keys";

/**
 * Side effect configurations for the integrations model.
 *
 * Currently handles Stripe subscription mutations (cancel, undo-cancel, pause, resume, update-payment-method)
 * which need to invalidate the Stripe subscriptions query to refresh the list.
 */
export const INTEGRATIONS_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"integrations"> =
  {
    proxy_write: (request) => {
      // Only handle Stripe subscription mutations
      if (request.integration !== "Stripe" || !request.type?.startsWith("subscription-")) {
        return {};
      }

      return {
        proxy_read: {
          exact: false,
          predicate: ({ queryKey }) => {
            const queryRequest = extractRequestFromQueryKey(queryKey);
            // Invalidate queries that fetch Stripe subscriptions
            return queryRequest?.integration === "Stripe" && queryRequest?.type === "subscriptions";
          },
        },
      };
    },
  };
